import React, { FC, memo } from 'react';
import styled from '@emotion/styled';

/**
 * Presentational radio: a ring that fills with a dot when checked. The row
 * that contains it owns the tap - tapping a checked radio should clear it,
 * which a native radio can't do, so the parent decides what a tap means.
 */
const Ring = styled.span`
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 2px solid var(--eposBorderColor);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease-out;

  &.is-checked {
    border-color: var(--eposButton);
  }
`;

const Dot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: var(--eposButton);
  transform: scale(0);
  transition: transform 0.15s cubic-bezier(0.22, 1, 0.36, 1);

  .is-checked & {
    transform: scale(1);
  }
`;

interface Props {
  checked: boolean;
  className?: string;
}

const RadioButton: FC<Props> = ({ checked, className }) => (
  <Ring
    role="radio"
    aria-checked={checked}
    className={[className, checked && 'is-checked'].filter(Boolean).join(' ') || undefined}>
    <Dot />
  </Ring>
);

export default memo(RadioButton);
